// inline-product-cards.js
(function () {
  if (!document.body || !document.body.innerHTML.includes('[[product:')) return;

  const money = (cents, currency = (window.Shopify && Shopify.currency) ? Shopify.currency.active : 'JPY') =>
    new Intl.NumberFormat('ja-JP', { style: 'currency', currency }).format((parseInt(cents, 10) || 0) / 100);

  // 1) 記事本文内の [[product:handle]] プレースホルダを探す
  const placeholders = [];
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
    acceptNode(n) {
      // JSON-LDなど、本文として置換すべきでない要素内は除外
      if (n.parentElement && n.parentElement.closest('script, style, noscript, textarea, template')) {
        return NodeFilter.FILTER_REJECT;
      }

      return (/\[\[product:([^\]]+)\]\]/).test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
    }
  });

  while (walker.nextNode()) placeholders.push(walker.currentNode);

  // 2) 置換レンダリング
  placeholders.forEach(node => {
    const txt = node.nodeValue;
    const regex = /\[\[product:([^\]]+)\]\]/g;
    const frag = document.createDocumentFragment();
    let lastIndex = 0, m;

    while ((m = regex.exec(txt)) !== null) {
      // 手前のテキスト
      if (m.index > lastIndex) frag.appendChild(document.createTextNode(txt.slice(lastIndex, m.index)));

      // ハンドル抽出（URLが入っていてもOK）
      let handle = m[1].trim();
      if (handle.includes('/products/')) {
        handle = handle.split('/products/')[1].split(/[/?#]/)[0];
      }

      const mount = document.createElement('div');
      mount.className = 'ipc-mount';
      mount.dataset.handle = handle;
      frag.appendChild(mount);

      lastIndex = regex.lastIndex;
    }
    // 残りのテキスト
    frag.appendChild(document.createTextNode(txt.slice(lastIndex)));
    node.parentNode.replaceChild(frag, node);
  });

  // 3) 各マウントにカードを描画
  const mounts = document.querySelectorAll('.ipc-mount');
  mounts.forEach(async (el) => {
    const handle = el.dataset.handle;
    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('not found');
      const product = await res.json();

      // 価格（最小/比較価格）計算
      const avail = product.variants.filter(v => v.available);
      const allPrices = product.variants.map(v => parseInt(v.price, 10));
      const minPrice = Math.min.apply(null, allPrices);
      const maxCompare = Math.max.apply(null, product.variants.map(v => parseInt(v.compare_at_price || 0, 10)));
      const onSale = maxCompare > minPrice;

      // 画像
      const img = product.images && product.images[0] ? product.images[0] : null;

      // DOM
      const wrapper = document.createElement('div');
      wrapper.className = 'ipc-card';

      const media = document.createElement('div');
      media.className = 'ipc-media';
      media.innerHTML = img ? `<img loading="lazy" decoding="async" alt="${product.title.replace(/"/g,'&quot;')}" src="${img}">` : '';

      const info = document.createElement('div');

      const title = document.createElement('h3');
      title.className = 'ipc-title';
      title.innerHTML = `<a href="${product.url}" class="ipc-link">${product.title}</a>`;

      const vendor = product.vendor ? `<div class="ipc-vendor">${product.vendor}</div>` : '';

      const price = document.createElement('div');
      price.className = 'ipc-price';
      price.innerHTML = `
        <span class="cur">${money(minPrice)}</span>
        ${onSale ? `<span class="cmp">${money(maxCompare)}</span><span class="ipc-badge">SALE</span>` : ''}
      `;

      // バリアント選択
      const variantsWrap = document.createElement('div');
      variantsWrap.className = 'ipc-variants';
      const hasMultiple = product.variants.length > 1;
      variantsWrap.innerHTML = hasMultiple ? `
        <label style="display:block;margin-bottom:4px;font-size:.85rem;color:#6b7280">バリエーション</label>
        <select aria-label="バリエーションを選択">
          ${product.variants.map(v => `<option value="${v.id}" ${v.available ? '' : 'disabled'}>${v.title} ${v.available ? '' : '(在庫なし)'}</option>`).join('')}
        </select>
      ` : '';

      // アクション
      const actions = document.createElement('div');
      actions.className = 'ipc-actions';
      const btn = document.createElement('button');
      btn.className = 'ipc-btn';
      btn.textContent = avail.length ? 'カートに追加' : '在庫なし';
      btn.disabled = avail.length === 0;

      // 追加先バリアントID
      const initialId = avail.length ? avail[0].id : (product.variants[0] ? product.variants[0].id : null);
      let selectedId = initialId;

      // セレクト変更
      if (hasMultiple) {
        const select = variantsWrap.querySelector('select');
        if (select) {
          // 初期は最初の在庫ありに合わせる
          const firstAvailable = product.variants.find(v => v.available);
          if (firstAvailable) select.value = String(firstAvailable.id);
          selectedId = firstAvailable ? firstAvailable.id : parseInt(select.value, 10);
          select.addEventListener('change', (e) => {
            selectedId = parseInt(e.target.value, 10);
          });
        }
      }

      // カート投入
      btn.addEventListener('click', async () => {
        if (!selectedId) return;
        btn.disabled = true;
        btn.textContent = '追加中…';
        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: selectedId, quantity: 1 })
          });
          if (!r.ok) throw new Error('cart/add failed');
          // テーマにドロワーがなければカートへ遷移
          btn.textContent = '追加しました！';
          setTimeout(() => { try{document.dispatchEvent(new CustomEvent('ipc:cart-added'));}catch(_){}; window.location.href = '/cart'; }, 300);
        } catch (e) {
          btn.textContent = '失敗しました';
          console.error(e);
          setTimeout(()=>{ btn.textContent = 'カートに追加'; btn.disabled = false; }, 1200);
        }
      });

      actions.appendChild(btn);
      const link = document.createElement('a');
      link.href = product.url;
      link.className = 'ipc-link';
      link.textContent = '商品ページへ';
      actions.appendChild(link);

      info.appendChild(title);
      if (vendor) info.insertAdjacentHTML('beforeend', vendor);
      info.appendChild(price);
      if (hasMultiple) info.appendChild(variantsWrap);
      info.appendChild(actions);

      wrapper.appendChild(media);
      wrapper.appendChild(info);

      el.replaceWith(wrapper);
    } catch (e) {
      console.warn('Inline product failed for handle:', handle, e);
      const fallback = document.createElement('div');
      fallback.textContent = `商品が見つかりませんでした: ${handle}`;
      el.replaceWith(fallback);
    }
  });
})();